<template>
  <div>
    <div v-if='props.isLoading && state.isSlow' class='flex justify-center items-center min-h-full'>
      <LoadingIcon class='text-jananavy-600 w-6 h-6' />
    </div>
    <slot v-else />
  </div>
</template>

<script setup>

import { reactive, watch, onMounted } from 'vue';

import LoadingIcon from '@/components/icons/loading-icon.vue';

const props = defineProps({
  isLoading: Boolean,
  slownessThreshold: {
    type: Number,
    default: 200
  }
});

const state = reactive({
  isSlow: false
});

let timeout = null;

const reset = () => {
  state.isSlow = false;
  
  clearTimeout(timeout);
  
  timeout = setTimeout(() => {
    state.isSlow = true;
  }, props.slownessThreshold);
}

watch(() => props.isLoading, () => {
  reset();
});

onMounted(() => {
  reset();
});

reset();

</script>